// DS2.4
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink, { Props as BaseButtonProps } from '../PlainButtonOrLink';
import { Props as IconProps } from '../../Icons/IconWrap';
import { ButtonSize } from '../types';
import useIconSizeForButtonSize from '../hooks/useIconSizeForButtonSize';
import s from './BuyButton.scss';

export interface Props extends BaseButtonProps {
  size: ButtonSize;
  icon?: React.ComponentType<IconProps>;
  postfixIcon?: React.ComponentType<IconProps>;
  children?: React.ReactNode;
  variant?: 'outline' | 'solid' | 'highlighted';
  rounded?: boolean;
}

const BuyButton: React.FC<Props> = ({
  size,
  fillContainerWidth,
  className,
  children,
  icon: IconComponent,
  postfixIcon: PostFixIconComponent,
  loading,
  rounded,
  variant = 'outline',
  ...props
}) => {
  const iconSize = useIconSizeForButtonSize(size);

  return (
    <PlainButtonOrLink
      className={classnames(
        className,
        s['root'],
        s[`size-${size}`],
        fillContainerWidth && s['fill-container-width'],
        props.disabled && s['disabled'],
        loading && s['loading'],
        rounded && s['rounded'],
        variant === 'solid' && s['variant-solid'],
        variant === 'highlighted' && s['variant-highlighted']
      )}
      {...props}
    >
      {IconComponent && (
        <IconComponent className={s['icon']} size={iconSize} disableDefaultColors />
      )}
      <span className={s['content']}>{children}</span>
      {PostFixIconComponent && (
        <PostFixIconComponent className={s['icon']} size={iconSize} disableDefaultColors />
      )}
    </PlainButtonOrLink>
  );
};
BuyButton.displayName = 'BuyButton';

export default BuyButton;
